import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiProperty, ApiTags } from "@nestjs/swagger";
import { VendorBanksService } from "./vendor-banks.service";
import { VendorBanksResponseModel } from "libs/shared-models/masters/src/lib/vendor-banks/vendor-banks-response-model";
import { BankNamesDTO } from "./vendor-banks.dto";



@ApiTags('vendor-banks')
@Controller('vendor-banks')
export class VendorBanksController {
    constructor(
        private service: VendorBanksService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }



    @Post('/bankNamesService')
    @ApiBody({type:BankNamesDTO})
    async BankNamesuploadExcel(@Body() data:any): Promise<VendorBanksResponseModel>{
       try{
        return this.service.BankNamesuploadExcel(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(VendorBanksResponseModel,err);
       }
    }


    @Post('/getBankNames')
    async getBankNames(): Promise<VendorBanksResponseModel> {
        try {
            return this.service.getBankNames();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(VendorBanksResponseModel, err);

        }
    }

}